import { useQuery } from '@apollo/client/react';

import { UserContextDocument } from '../../../__generated__/athena/graphql';

export const useAthenaSessionQuery = () => {
  const { data, loading, error } = useQuery(UserContextDocument, {
    context: {
      clientName: 'athena',
    },
  });
  const customerUuid = data?.web.userSession?.human?.customer_uuid;
  const email = data?.web.userSession?.human?.email;
  const fullName = data?.web.userSession?.human?.full_name;
  const impersonated = Boolean(data?.web.userSession?.human?.impersonated);
  return { customerUuid, email, fullName, impersonated, data, loading, error };
};
